import {ChangeDetectionStrategy, Component} from "@angular/core";
import {ChewzieLogoComponent} from "../chewzie-logo/chewzie-logo.component";
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: "woa-chewzie-attribution",
    templateUrl: "./chewzie-attribution.component.html",
    styleUrl: "./chewzie-attribution.component.scss",
    imports: [
        ChewzieLogoComponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChewzieAttributionComponent {
}
